import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const RestoredRowContainer = styled.div`
  width: 100%;
  padding: ${pxToRem(10)} ${pxToRem(20)};
  background: rgb(86, 189, 116);

  display: flex;
  justify-content: left;
  align-items: center;
  padding: ${pxToRem(6)} ${pxToRem(25)};
`;

export const RestoredRowMessage = styled.span`
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(18)};
  font-weight: 400;
  padding-left: ${pxToRem(32)};
`;
